import * as Api from '@ViewModels';
import { StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { formatCampaignSendMethod } from '../../../../models/utils/campaignUtils';
import { THEME } from '../../../components-v2/Theme/theme';
import { baseStyleSheet } from '../../../styles/styles';

const styleSheet = StyleSheet.create({
	overlapDisclaimer: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
		textAlign: 'left',
	},
});

const overlapDisclaimerText = 'Other campaigns scheduled in the same window can extend the actual completion time.';

interface ISendSpeedDisplayProps {
	campaign?: Api.ICampaign;
	className?: string;
}

/**
 * Displays the send speed for a campaign (e.g., "As quickly as possible" or "Spread over X days").
 * Returns null if campaign is cancelled or send method cannot be determined.
 */
export const SendSpeedDisplay: React.FC<ISendSpeedDisplayProps> = ({ campaign, className }) => {
	// Check if campaign is cancelled first to avoid unnecessary computation
	if (campaign?.cancelledDate) {
		return null;
	}

	const sendMethodText = formatCampaignSendMethod(campaign);

	if (!sendMethodText) {
		return null;
	}

	return (
		<div className={className}>
			<div>
				<span className={css(baseStyleSheet.fontBold)}>Send Speed: </span>
				<span>{sendMethodText}</span>
			</div>
			<div className={css(styleSheet.overlapDisclaimer)}>{overlapDisclaimerText}</div>
		</div>
	);
};
